export default {
	inject: ['setSelected'],
	props: {
		selected: Boolean,
		displayName: String,
		focused: Boolean,
		height: {
			type: String,
			default: '32px',
		}
	},
	computed: {
		itemStyle() {
			return {
				height: this.height,
				lineHeight: this.height,
			};
		},
	},
	methods: {
		onSelect(event) {
			this.setSelected(this.value, event);
		},
	},
};
